import  React from 'react';
import  "./settlement.scss";
import close from '../../static/images/close.svg';
import  { termsConditions} from "./constants";

const TermsAndConditions = ({
    setModalOpen,
    isOpen
}) => {

    if (!isOpen) {
        return <></>;
    }

    return (
        <div className="modal-overlay two">
            <div className={'modal-content custom-modal-content'}>
                <div className={'model-header-container'}>
                    <h3>Terms & Conditions</h3>
                    <img
                        src={close}
                        alt="Close"
                        className="close"
                        onClick={() => setModalOpen(false)}
                    />
                </div>
                <p>
                    {termsConditions}
                </p>
            </div>
        </div>
    );
};

export default TermsAndConditions;
